var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.recipientsData, function (recipient, index) {
      return _c(
        "div",
        { key: index, staticClass: "eu-pb_5" },
        [
          _vm.splits && _vm.splits.length > 0
            ? _c(
                "recipient-header",
                _vm._b(
                  { attrs: { id: `recipientHeader-${index}` } },
                  "recipient-header",
                  _vm.mountDataHeader(recipient, index),
                  false
                )
              )
            : _c(
                "div",
                { staticClass: "emd-container _highlight_header no-border" },
                [
                  _c("div", { staticClass: "emd-container__header" }, [
                    _c(
                      "h2",
                      { staticClass: "emd-text _size_default _type_caption" },
                      [_vm._v(" " + _vm._s(_vm.$t("header")) + " ")]
                    ),
                  ]),
                ]
              ),
          recipient.payable_installment &&
          recipient.payable_installment.length > 0
            ? _c(
                "div",
                [
                  recipient.collapsed
                    ? _c("transaction-recipient-installments", {
                        attrs: {
                          rows: recipient.payable_installment,
                          formatValue: _vm.formatValue,
                          id: `installment-${index}`,
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "footer-collapsed eu-py_3 eu-display_flex eu-justify_center",
                    },
                    [
                      recipient.collapsed
                        ? _c(
                            "div",
                            {
                              staticClass: "emd-text _size_regular",
                              on: {
                                click: function ($event) {
                                  return _vm.onChangeCollapse(
                                    recipient.recipient_id,
                                    recipient.collapsed
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "charge.detail.recipients.not-collapsed-installments"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("i", { staticClass: "uil uil-angle-up" }),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "emd-text _size_regular",
                              attrs: {
                                id: `notCollapsedInstallments-${index}`,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onChangeCollapse(
                                    recipient.recipient_id,
                                    recipient.collapsed
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "charge.detail.recipients.collapsed-installments"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("i", { staticClass: "uil uil-angle-down" }),
                            ]
                          ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }